import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/AddButton";
import { edit, Plus, map, placeMareker } from "../../../common/svg";
import { Documents } from "../../../common/staticData";
import CustomCard from "../../../components/Card";
// import Carousel from "../../../components/Carousel/index"
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomChip from "../../../components/Chip";
import SecureImage from "../../../components/BucketImage/Image";
import DeliveryTimeline from "../../../components/DeliveryTimeline";
import { booking } from "../../../common/svg";
const Routes = () => {
  const [activeTripCard, setActiveTripCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [isWhite, setIsWhite] = useState(false);

  useEffect(() => {
    const handleClick = () => setIsWhite(true);
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
  const handleClick = () => {
    console.log("Button clicked!");
  };
  const handleViewDetails = (index: number) => {
    setActiveTripCard(index);
    setViewTripDetails(true);
  };
  const [isEditing, setIsEditing] = useState(false);
  const [routeInfo, setRouteInfo] = useState({
    code: "EN14245",
    start: "Chennai Manali Yard",
    end: "Ennore Port",
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const parts = value.split(" – "); // Split input by " – "

    if (parts.length === 3) {
      setRouteInfo({
        code: parts[0],
        start: parts[1],
        end: parts[2],
      });
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  return (
    <div>
      <div className="bg-white p-2  mt-3 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className=" text-[#444FBD] text-[16px]  font-[600]">
            Documents (03)
          </p>
          <CustomButton label="" icon={Plus} onClick={handleClick} />
        </div>
        <br />
        <div className="flex gap-2 mt-">
          {/* Left */}
          <div>
            {Documents.map((booking, index) => (
              <CustomCard
                key={index}
                onClick={() => handleViewDetails(index)}
                isActive={activeTripCard === index}
                className="w-[400px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
              >
                <div className="gap-[-1]">
                  {/* Top Section: Booking Name and Trip Status */}
                  <div className="flex justify-between items-center ">
                    <div className="flex items-center space-x-2">
                      <p className="font-Poppins">{booking.Trip}</p>
                    </div>
                    <p className=" font-[400] text-[14px]">#0{index + 1}</p>
                  </div>
                  {/* Booking Details */}
                  <div className=" flex justify-between">
                    <div className="leading-[18px] felx flex-col items-start">
                      <span>{booking.bookingId}</span>
                      <p className="text-[14px]">{booking.bookingDate}</p>
                    </div>
                  </div>

                  {/* Client Name with Conditional Styling */}
                  <div className="flex justify-between items-end">
                    <div className="flex flex-col leading-[15px]">
                      <p
                        className={`font-medium text-[14px]  ${
                          activeTripCard === index ? "text-[# ]" : "text-[# ]"
                        }`}
                      ></p>
                    </div>
                  </div>
                </div>
              </CustomCard>
            ))}
          </div>
          {viewTripDetails && (
            <div className="mt-[-20px] w-full border-l border-[#C1C1C1] border-dashed">
              {viewTripDetails && (
                <div className="flex flex-col w-full">
                  <div className="flex flex-col gap-4">
                    <div className=" w-full">
                      <div className="flex justify-between items-start w-full">
                        <div className="flex items-center">
                          <SecureImage
                            fileKey={booking}
                            alt="header icon"
                            width="55px"
                          />
                          <p className="text-[20px] text-[#282828] font-[600] font-Poppins ml-4">
                            Booking Documents
                          </p>
                        </div>

                        <div className="flex items-center gap-2">
                          <CustomButton
                            label=""
                            icon={Plus}
                            onClick={handleClick}
                          />
                          <CustomButton
                            label=""
                            icon={edit}
                            onClick={handleEditClick}
                          />
                        </div>
                      </div>
                      <div className="ml-6  flex items-center gap-2">
                        <p className="text-[16px] text-[#282828] font-[400] font-Poppins ml-12">
                          No of Files
                        </p>
                        <p className="text-[16px] text-[#282828] font-[400] font-Poppins ml-5">
                          25
                        </p>
                      </div>
                      <div className="border-b border-[#C1C1C1] border-dashed p-2"></div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 mt-5 ml-6"> 
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRGyrh7OkERY54CEtqUerCHNhfAmoCrKpF5g&s"
                      alt="construction"
                    />
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRGyrh7OkERY54CEtqUerCHNhfAmoCrKpF5g&s"
                      alt="construction"
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Routes;
